import { createClient, type Session, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

let browserClient: SupabaseClient | null = null

export function isSupabaseConfigured() {
  return Boolean(supabaseUrl && supabaseAnonKey)
}

export function getSupabaseClient() {
  if (!isSupabaseConfigured()) {
    return null
  }

  if (!browserClient) {
    browserClient = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  }

  return browserClient
}

export async function getSupabaseSession() {
  const client = getSupabaseClient()
  if (!client) {
    return null
  }

  const { data } = await client.auth.getSession()
  return data.session
}

export async function signInAdmin(email: string, password: string) {
  const client = getSupabaseClient()
  if (!client) {
    throw new Error('Supabase is not configured.')
  }

  const { error } = await client.auth.signInWithPassword({
    email,
    password,
  })

  if (error) {
    throw error
  }
}

export async function signOutAdmin() {
  const client = getSupabaseClient()
  if (!client) {
    return
  }

  await client.auth.signOut()
}

export function subscribeAuthStateChange(callback: (session: Session | null) => void) {
  const client = getSupabaseClient()
  if (!client) {
    return () => undefined
  }

  const {
    data: { subscription },
  } = client.auth.onAuthStateChange((_event, session) => {
    callback(session)
  })

  return () => {
    subscription.unsubscribe()
  }
}
